module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-heatmap-d1f8499479f5b5fb0b88ad6b07fc8d3f.gif";